import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ESignService } from 'src/app/services/e-sign.service';

@Injectable({
  providedIn: 'root'
})
export class ShareSignAuthGuard implements CanActivate {
  
  constructor(private esignService: ESignService, private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.esignService.isShareSignVerified) {
      return true;
    }

    this.router.navigate(['/public-sign-link']);
    return false;
  }
}